import { render, staticRenderFns } from "./addEditProduct.vue?vue&type=template&id=66f83c0a&"
import script from "./addEditProduct.vue?vue&type=script&lang=js&"
export * from "./addEditProduct.vue?vue&type=script&lang=js&"
import style0 from "./addEditProduct.vue?vue&type=style&index=0&id=66f83c0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports